import DefaultHeroImage from '../definitions/DefaultHeroImage';


/**
 * Utility function to extract the featured media from a post
 * 
 * NOTE: If the size you want isn't available in `rh_featured_media`
 * this will still return `rh_featured_media` anyways and leaves you
 * with no way to use the DefaultHeroImage. I'm not totally sure
 * how useful this is then. Basically this assumes you are using
 * "full".
 *
 * @param {object} post WP post
 * @returns {object} Featured media
 */
export default function getFeaturedMedia(post) {
    return post.rh_featured_media || DefaultHeroImage;
}